export default __webpack_public_path__ + "static/media/beginners2.b1840d99.png";